module.exports = __webpack_public_path__ + "img/nav-logo.ec943af2.png";